import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await fetch(`${BACKEND_URL}/api/admin/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ password })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        // Store token in session storage
        sessionStorage.setItem('adminToken', data.token);
        sessionStorage.setItem('adminAuth', 'true');
        toast.success('Login successful!');
        navigate('/admin/dashboard');
      } else {
        toast.error(data.detail || 'Invalid password');
        setPassword('');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 via-teal-50 to-emerald-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-2 border-cyan-300 shadow-xl">
        <CardHeader className="bg-gradient-to-r from-cyan-600 to-teal-600 text-white rounded-t-lg">
          <CardTitle className="text-2xl flex items-center justify-center">
            <Lock className="mr-2 h-6 w-6" />
            Admin Login
          </CardTitle>
          <p className="text-center text-cyan-50 text-sm mt-2">Shubh Wellness Clinic</p>
        </CardHeader>
        <CardContent className="p-6">
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="password" className="text-gray-700 font-semibold">
                Admin Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="mt-2 border-2 border-cyan-200 focus:border-cyan-500 h-12"
                required
                disabled={isLoading}
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-gradient-to-r from-cyan-600 to-teal-600 hover:from-cyan-700 hover:to-teal-700 text-white h-12 text-lg"
              disabled={isLoading}
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </Button>
          </form>

          <div className="mt-6 p-4 bg-cyan-50 border border-cyan-200 rounded-lg">
            <p className="text-sm text-gray-600 text-center">
              <strong>Default Password:</strong> Shubh2026Admin
            </p>
            <p className="text-xs text-gray-500 text-center mt-1">
              (Contact developer to change password)
            </p>
          </div>

          <button
            onClick={() => navigate('/')}
            className="w-full mt-4 text-cyan-600 hover:text-cyan-700 font-medium text-sm"
          >
            ← Back to Website
          </button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
